import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";

import Visibility from "../components/Styles/assets/Graphics/Visibility.webp";
import Engagement from "../components/Styles/assets/Graphics/Engagement.webp";
import CostEffective from "../components/Styles/assets/Graphics/CostEffective.webp";
import Performance from "../components/Styles/assets/Graphics/Performance.webp";
import Brand from "../components/Styles/assets/Graphics/Brand.webp";
import Growth from "../components/Styles/assets/Graphics/Growth.webp";
import Competitive from "../components/Styles/assets/Graphics/Competitive.webp";

import img16 from "../components/Styles/assets/img16.webp";
import { Link } from "react-router-dom";
import Consultation from "../components/Consultation";

import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";

function SocialMedia() {
  const { i18n, t } = useTranslation();

  const advantages = [
    "visibility",
    "engagement",
    "costEffective",
    "performance",
    "brand",
    "growth",
    "competitive"
  ];

  const icons = {
    visibility: Visibility,
    engagement: Engagement,
    costEffective: CostEffective,
    performance: Performance,
    brand: Brand,
    growth: Growth,
    competitive: Competitive
  };

  return (
    <StyledService.Container>
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>{t("socialMedia.title")}</StyledService.Title>
          <StyledService.Description>{t("socialMedia.description")}</StyledService.Description>
          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>{t("socialMedia.cta")}</StyledButton.Main>
          </Link>
        </StyledService.Content>
        <StyledService.ImageContainer>
          <img
            src={img16}
            alt={t("socialMedia.title")}
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      <StyledService.H3 lang={i18n.language}>{t("socialMedia.advantagesTitle")}</StyledService.H3>

      <StyledHCard.Container>
        {advantages.map((key) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icons[key]} alt={key} />
            </StyledHCard.IconContainer>
            <StyledHCard.Content>
              <StyledHCard.Title>{t(`socialMedia.advantages.${key}.title`)}</StyledHCard.Title>
              <StyledHCard.Description>{t(`socialMedia.advantages.${key}.desc`)}</StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledService.Container>
  );
}

export default SocialMedia;